<template>
    <div>
        <div
            class="innerBox"
            style="
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 7.5px 10px;
            "
        >
            <button
                class="btn"
                style="
                    font-size: 16px;
                    color: #6c6c6c;
                    font-weight: bold;
                    padding: 4px;
                "
                @click="$router.go(-1)"
            >
                <i class="fas fa-angle-left mr-2"></i>Back
            </button>
            <p
                class="mb-0"
                style="font-size: 16px; color: #b9b9b9; font-weight: 600"
            >
                | Truck List >> See Details <i class="fas fa-angle-right"></i>
            </p>
            <p
                class="mb-0 ml-1"
                style="font-size: 16px; color: #4b4b4b; font-weight: bold"
            >
                {{ truckDetail.nopol }}
            </p>
        </div>

        <div class="innerBox mt-4">
            <div
                class="div"
                style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                "
            >
                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 20px"
                            >Nopol</label
                        >
                    </div>
                    <div>
                        <label>
                            <label style="color: #000000; font-size: 20px">{{
                                truckDetail.nopol
                            }}</label>
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 20px"
                            >Ekspedisi</label
                        >
                    </div>
                    <div>
                        <label>
                            <label style="color: #000000; font-size: 20px">{{
                                truckDetail.nama_ekspedisi
                            }}</label>
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 20px"
                            >Tipe Truck</label
                        >
                    </div>
                    <div>
                        <label>
                            <label style="color: #000000; font-size: 20px">{{
                                truckDetail.type_truck
                            }}</label>
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 20px"
                            >Tanggal Efektif</label
                        >
                    </div>
                    <div>
                        <label>
                            <label style="color: #000000; font-size: 20px">{{
                                truckDetail.startdate
                            }}</label>
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 20px"
                            >Tanggal Non-Efektif</label
                        >
                    </div>
                    <div>
                        <label>
                            <label style="color: #000000; font-size: 20px">{{
                                truckDetail.enddate
                            }}</label>
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 20px"
                            >Status Truck</label
                        >
                    </div>
                    <div>
                        <label>
                            <label style="color: #000000; font-size: 20px">{{
                                truckDetail.status_truck
                            }}</label>
                        </label>
                    </div>
                </div>
            </div>

            <div
                class="mt-5 ml-4 f-25"
                style="display: flex; flex-direction: column"
            >
                <label style="color: #000000; font-size: 17px"
                    >Detailed Information</label
                >
            </div>

            <div
                style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                "
            >
                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 17px"
                            >Status Workflow</label
                        >
                    </div>
                    <div>
                        <label style="color: #000000; font-size: 17px">
                            <h5>{{ truckDetail.status_workflow }}</h5>
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 17px"
                            >Kategori Truck</label
                        >
                    </div>
                    <div>
                        <label style="color: #000000; font-size: 17px">
                            <h5>{{ truckDetail.truck_category }}</h5>
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 17px"
                            >Odol</label
                        >
                    </div>
                    <div>
                        <label style="color: #000000; font-size: 17px">
                            {{ truckDetail.odol }}
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 17px"
                            >Kapasitas Packing</label
                        >
                    </div>
                    <div>
                        <label style="color: #000000; font-size: 17px">
                            {{ truckDetail.packing_capacity }}
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 17px"
                            >Kapasitas Build-Up</label
                        >
                    </div>
                    <div>
                        <label style="color: #000000; font-size: 17px">
                            {{ truckDetail.buildup_capacity }}
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 17px"
                            >Tahun Produksi</label
                        >
                    </div>
                    <div>
                        <label style="color: #000000; font-size: 17px">
                            {{ truckDetail.production_year }}
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 17px"
                            >Usia Truck</label
                        >
                    </div>
                    <div>
                        <label style="color: #000000; font-size: 17px">
                            {{ new Date().getFullYear() - truckDetail.production_year }} Tahun
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 17px"
                            >Asuransi</label
                        >
                    </div>
                    <div>
                        <label style="color: #000000; font-size: 17px">
                            {{ truckDetail.insurance }}
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column"
                >
                    <div>
                        <label style="color: #bcbcbc; font-size: 17px"
                            >GPS</label
                        >
                    </div>
                    <div>
                        <label style="color: #000000; font-size: 17px">
                            {{ truckDetail.gps }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Datepicker from "vue-datepicker";
import { BFormSelect } from "bootstrap-vue";

export default {
    metaInfo: {
        title: "Create Muatan",
    },
    data() {
        return {
            filter: {
                nopol: null,
            },
            truckDetail: {},
            selectedDate: null,
            selectedSearchResult: null,
            searchQuery: "",
            searchResults: [{ value: "Pilih Nopol" }, { value: "Pilih Nopol" }],
        };
    },
    components: {
        Datepicker,
        BFormSelect,
    },
    mounted() {
        this.truckDetail = JSON.parse(this.$store.state.truckData);
        if (this.truckDetail == null) this.goBack();
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style scoped>
.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
}

.chart {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
    align-items: center;
}

.elegant--sub-title {
    font-size: 18px;
    font-weight: 500;
    color: #4d4d4d;
}

/* .center {
          padding: 50px 20px;
          display: flexbox;
          flex-direction: column;
          align-items: center;
          justify-content: center;
      } */

.stats--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.table td,
.table th {
    text-align: center;
}

.news-image-1 img {
    max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
    text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
    text-align: left; /* To position the news-content on the bottom right */
}

.search-container {
    display: flex;
    align-items: center;
}

.dropdown-container {
    flex: 1;
    margin-right: 10px;
}

.searchbar-container {
    flex: 2;
}

.dropdown {
    width: 100%;
}

.searchbar {
    width: 50%;
    padding: 5px;
}
</style>
